import React, { ReactNode } from 'react';

export const ValidationErrorMessage = (props: { children: ReactNode }) => {
  return (
    <>
      <span className={`text-xs text-red-600`}>{props.children}</span>
    </>
  );
};
